import React, { useEffect, useState } from 'react';
import { AlertMessage } from '../../components/AlertMessage/AlertMessage';
import PropTypes from 'prop-types';

/* LOCAL STYLES IMPORT FOR THE COMPONENT */
import '../../assets/components/AddressList.scss'; 


export const AddressList = ({ addressList, getSelectedAddress }) => {
    const [inputValue, setInputValue] = useState("");
    const [returnValue, setReturnValue] = useState([]);

    useEffect(()=>{
        setReturnValue(addressList && addressList);
    },[addressList])

    useEffect(() => {
        const filteredAddresses = addressList.filter(address =>
            address.text.includes(inputValue)
        );

        setReturnValue(filteredAddresses);
      }, [inputValue]);

    return (
        <>
            <label htmlFor="searchAddress" className="form-label">Select Property Address</label>
                <div>
                    <div className="search-select-container postcode-input">
                    <div className="input-group mb-3">
                        <input type="text" value={inputValue} name="search_searchAddress" id="search_searchAddress" autoComplete="off" className="form-control" onChange={event => setInputValue(event.target.value)} />
                        {inputValue.length > 0 && <button className="btn btn-danger" type="button" id="button-addon2" onClick={()=>setInputValue('')}>Clear</button>}
                    </div>        
                            <div className="search-select-list">
                                { returnValue.length > 0 ? 
                                    returnValue && returnValue.map((address, index)=>{
                                        return(
                                            <button key={ index } type="button" className="item" onClick={()=>getSelectedAddress(address)}> 
                                                { address.text }
                                            </button>
                                            );
                                        }) :
                                        <div className="postcode-input">
                                            <AlertMessage message={`0 matches for '${inputValue}'`}  alertType="alert alert-danger"  />
                                        </div>
                                }
                            </div>
                    </div>
                </div>
        </>
    );
};

AddressList.propTypes = {
    /* 
      list of addresses to be displayed
    */ 
    addressList: PropTypes.array.isRequired,
  }
  
AddressList.defaultProps = {
    /*
     default value of the list of address
    */
    addressList: [],
}